import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import TopHeader from '../components/layout/TopHeader';

const SIDEBAR_COLLAPSED_KEY = 'gpacs.sidebar.collapsed';

function AppLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true';
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  const handleToggleSidebar = () => {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      setIsSidebarCollapsed((prev) => !prev);
      return;
    }
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <div className="flex h-screen overflow-hidden bg-slate-50">
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={handleToggleSidebar}
        isCollapsed={isSidebarCollapsed}
      />

      <div className={`flex h-screen min-h-0 flex-1 flex-col overflow-hidden ${isSidebarCollapsed ? 'lg:ml-16' : 'lg:ml-60'}`}>
        <div className={`fixed left-0 right-0 top-0 z-30 ${isSidebarCollapsed ? 'lg:left-16' : 'lg:left-60'}`}>
          <TopHeader onToggleSidebar={handleToggleSidebar} isSidebarCollapsed={isSidebarCollapsed} />
        </div>

        <main className="flex-1 min-h-0 overflow-hidden p-4 pt-14 lg:p-6 lg:pt-[4.5rem]">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AppLayout;